import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VBtn,{staticClass:"mb-n1",attrs:{"text":"","color":"primary-color","title":"Back to Publish Amp"},on:{"click":_vm.back}},[_c(VIcon,{attrs:{"small":"","left":""}},[_vm._v("arrow-left")]),_vm._v(" Back to Publish Amp ")],1),_c('loa-customer',{staticClass:"pa-0 mt-4",on:{"saved":_vm.back,"before-leave":_vm.setLeaveHook}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }